// ONE-SHOT mute for select-driven scrollIntoView effects.
//
// Switching browser tabs (or the chain/device space) remounts the lists, and
// mount re-fires every `useEffect(..., [selected])` — the selected row would
// hijack the scroll position Upstage just restored. Tab/space switch handlers
// call mute(); Upstage unmutes in a passive effect, which React runs after all
// child mount effects of the same commit.
let muted = false

export const SelectScroll = {
    mute: () => { muted = true },
    unmute: () => { muted = false },
    muted: () => muted,
}
